<template>
  <div class="seller-contact-information-wrapper">
    <SellerContactCard
      v-for="(contact, index) in contacts "
      :contact="pruneContact(contact)"
      :index="index + 1"
      :key="index"
    />
  </div>
</template>

<script>
import SellerContactCard from '@/components/Info/Cards/SellerContactCard';
import account from '@/services/account';
import { dateFormat } from '@trendyol/sc-utils';
import CommonUtils from '@/utils/CommonUtils';
export default {
  name: 'SellerContactInformation',
  components: { SellerContactCard },

  data () {
    return {
      contacts: [],
    };
  },

  methods: {
    async getSellerContacts () {
      this.contacts = await account.getSellerContacts();
    },

    pruneContact (contact) {
      return {
        contactTypeName: contact.contactTypeName,
        fullName: contact.fullName,
        email: contact.email,
        phone: CommonUtils.makeReadablePhone(contact.phone, { prefix: '0' }),
        createDate: dateFormat.date(contact.createDate),
        description: contact.description,
      };
    },
  },

  created () {
    this.getSellerContacts();
  },
};
</script>

<style lang="scss" scoped>
  .seller-contact-information-wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  }

</style>
